import "./press-slider.component.css"
import { useEffect, useRef } from "react"
import Glide, {
  Controls,
  Breakpoints,
  Swipe,
} from "@glidejs/glide/dist/glide.modular.esm"
import "@glidejs/glide/dist/css/glide.core.css"
import { nextIcon, prevIcon } from "../../icons"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const PressSliderComponent = (props) => {
  const { Heading, Items } = props
  const glideRef = useRef()
  const elRef = useRef()

  const handleNav = (href) => {
    if (href && href.indexOf("https://") > -1) {
      window.open(href, "_blank")
    }
  }

  const createPressItem = (item) => {
    const { Heading, Subheading, Media } = item

    return (
      <div
        key={item.id}
        data-item-id={item.id}
        className="dagger-press-item glide__slide"
      >
        <div className="dagger-press-item-image" data-item-id={item.id}>
          <StrapiImageComponent
            attributes={Media?.data?.attributes}
            sizes="(max-width: 800px) 100vw, 50vw"
          />
        </div>
        <h6>{Heading}</h6>
        {Subheading && <h5>{Subheading}</h5>}
      </div>
    )
  }

  useEffect(() => {
    if (!elRef.current) return
    const imageEl = elRef.current.querySelector(".dagger-press-item-image")
    if (imageEl && elRef.current?.style) {
      const observer = new ResizeObserver(() => {
        if (!elRef.current) return
        const center = imageEl.offsetHeight / 2
        elRef.current.style.setProperty("--controls-top", `${center}px`)
      })
      observer.observe(imageEl)
      return () => observer.disconnect()
    }
  }, [Items])

  useEffect(() => {
    if (Items?.length < 1 || glideRef.current || !elRef.current) return

    glideRef.current = new Glide(elRef.current, {
      type: "carousel",
      startAt: 0,
      perView: 2,
      focusAt: 0,
      peek: {
        before: 0,
        after: 0,
      },
      breakpoints: {
        800: {
          perView: 1,
          peek: 0,
        },
      },
    }).mount({ Controls, Breakpoints, Swipe })
  }, [Items])

  const handleItemClick = (e) => {
    const slide = e.target.closest("[data-item-id]")
    if (slide) {
      const itemId = slide.getAttribute("data-item-id")
      const item = Items.find((i) => i.id.toString() === itemId)
      if (item) {
        handleNav(item.Link)
      }
    }
  }

  return (
    <div className="dagger-press-slider">
      <h6>{Heading}</h6>
      <div className="glide" ref={elRef}>
        <div className="dagger-press-items glide__track" data-glide-el="track">
          <div className="glide__slides" onClick={handleItemClick}>
            {Items?.filter(Boolean).map((i, ind) => createPressItem(i, ind))}
          </div>
        </div>
        <div data-glide-el="controls" className="glide-controls">
          <button data-glide-dir="<">{prevIcon}</button>
          <button data-glide-dir=">">{nextIcon}</button>
        </div>
      </div>
    </div>
  )
}

export default PressSliderComponent
